function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "40.9,39.1 47.3,39.1 44,22.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M136.2,5.5H12.8c-2.7,0-4.8,2.3-4.8,5v49.4c0,2.7,2.3,4.8,4.8,4.8h123.4c2.7,0,4.8-2.3,4.8-4.8V10.5 C141.1,7.8,138.9,5.5,136.2,5.5z M22.4,57.3c-3,0-5.7-1.5-7.5-5.3c-2.1-4.2-3.3-9.9-3.3-17.1c0-7.7,1.1-13.5,3.3-17.9 c2-3.8,4.4-5.6,7.7-5.6c2.6,0,4.8,1.4,6.5,4.2l-2.7,4.8c-0.9-1.4-2.7-2-3.9-2c-1.7,0-3.2,1.8-4.2,4.2c-1.1,2.4-1.7,6.3-1.7,11.7 c0,5.6,0.5,9.6,1.5,12s2.9,4.7,4.5,4.7c2.1,0,3.3-0.3,4.1-1.1l2.6,4.4C27.7,56.5,24.8,57.3,22.4,57.3z M50.8,56.8l-2-10.1h-9.3 l-2,10.1h-5l9-44.6h5l9.3,44.6H50.8z M77.5,56.8h-4.7l-9.3-29.1v29.1h-4.4V12.3h4.5L73.1,42V12.3h4.4V56.8z M93.9,57.6 c-3,0-5.7-1.5-7.5-5.3c-2.1-4.2-3.3-9.9-3.3-17.1c0-7.7,1.1-13.5,3.3-17.9c2-3.8,4.4-5.6,7.7-5.6c2.6,0,4.8,1.4,6.5,4.2l-2.7,4.8 c-0.9-1.4-2.7-2-3.9-2c-1.7,0-3.2,1.8-4.2,4.2c-1.1,2.4-1.7,6.3-1.7,11.7c0,5.6,0.5,9.6,1.5,12s2.9,4.7,4.5,4.7 c2.1,0,3.3-0.3,4.1-1.1l2.6,4.4C99.1,56.8,96.3,57.6,93.9,57.6z M120.4,56.8h-16.4V12.3H120v6.3h-11.3v12.3h9.2v6.3h-9.2v13.4h11.7 V56.8z M138,56.8h-13.8V12.6h4.7v37.8h9.2V56.8z"
}));

var SvgCancelIcon = function SvgCancelIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 73",
    style: {
      enableBackground: "new 0 0 150 73"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCancelIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancel-icon.0c518e75.svg";
export { ForwardRef as ReactComponent };